import axios from "axios";
import { getCookie } from "../../getcookie";
// import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const header = {
    'Content-Type': 'application/json; charset=UTF-8',
    "Accept": "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    "Authorization": getCookie("mawalog")
}





export const getalertConfigApi = async () => {

    try {
        const response = await axios.get(
            apiUrl + `alert_config`,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getalertDetailsApi = async (label) => {

    try {
        const response = await axios.get(
            apiUrl + `alert_config/get/` + label,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const alertSubmitApi = async (data) => {

    try {
        const response = await axios.post(
            apiUrl + `alert_config`, data, { headers: header }).then((response) => {
                return response;
            }).catch((error) => {
                console.log('error...', error.response)
                return error.response;

            });
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};